import React from 'react';
import { StatusTagEnum } from '@tryhackme/thm-ui-components';
import { useGetUserQuery } from 'src/common/slices';
import { useGetRoomDetailQuery } from 'src/features/room/room.slice';
import { useAppSelector } from 'src/app/hooks';
import { ROOM_CODE_ATTACK_BOX_FOR_FREE_USERS, ROOM_CODE_ATTACK_BOX_PREMIUM_OR_KALI } from 'src/common/constants/vms';
import { TaskType } from 'src/common/enums/task';
import { AttackBoxButton } from '../../../attack.box-button';
import { VirtualEnvironmentMachine } from './virtual-environment-machine';
import { StyledAttackBoxButtonWrapper } from './virtual-environment-machine.styles';
type VirtualEnvironmentAttackBoxProps = {
  roomCode: string;
  isConnected: boolean;
};
export const VirtualEnvironmentAttackBox: React.FC<VirtualEnvironmentAttackBoxProps> = ({
  roomCode,
  isConnected
}) => {
  const {
    isSuccess: isUserAuth
  } = useGetUserQuery();
  const {
    data: roomData
  } = useGetRoomDetailQuery(roomCode);
  const hasJoinedRoom = roomData?.data?.joined;
  const splitScreenTabs = useAppSelector(state => state.splitScreen.tabs);
  const isAttackBoxRunning = splitScreenTabs.some(tab => tab.type === TaskType.VM && tab.vm && [ROOM_CODE_ATTACK_BOX_PREMIUM_OR_KALI, ROOM_CODE_ATTACK_BOX_FOR_FREE_USERS].includes(tab.vm.roomCode));
  return <VirtualEnvironmentMachine title="Attacker machine" tooltipText="AttackBox is an Ubuntu Virtual Machine hosted in the cloud, allowing you to complete many tasks in our
                rooms. Think of the AttackBox as your virtual computer, which you would use to conduct a security
                engagement." tagTitle={isConnected ? 'Connected via Attackbox' : 'Off'} tagStatus={isConnected ? StatusTagEnum.GREEN : StatusTagEnum.RED} data-sentry-element="VirtualEnvironmentMachine" data-sentry-component="VirtualEnvironmentAttackBox" data-sentry-source-file="virtual-environment-attack-box.tsx">
      {isUserAuth && hasJoinedRoom && !isAttackBoxRunning && <StyledAttackBoxButtonWrapper>
          <AttackBoxButton />
        </StyledAttackBoxButtonWrapper>}
    </VirtualEnvironmentMachine>;
};